module.exports = __webpack_public_path__ + "d5d9c43b64693af90cd55e7c51fc59f4.png";